export default function Workshop() {
  const workshops = [
    {
      title: '跨部門破牆協作',
      description: '打破部門壁壘，建立真正的協作機制，讓團隊不再各自為政',
      duration: '3 小時工作坊',
      image: 'https://public.readdy.ai/ai/img_res/0a271d6883c476febfc103510d326a74.jpg'
    },
    {
      title: '衝突對話與修復',
      description: '學習如何面對衝突、處理分歧，將衝突轉化為團隊成長的契機',
      duration: '半天工作坊',
      image: 'https://readdy.ai/api/search-image?query=professional%20mediation%20and%20conflict%20resolution%20workshop%20with%20team%20members%20in%20constructive%20dialogue%2C%20indoor%20training%20room%20with%20facilitator%20guiding%20discussion%2C%20people%20engaged%20in%20active%20listening%20and%20communication%2C%20professional%20photography%20showing%20conflict%20management%20skills&width=600&height=400&seq=workshop002&orientation=landscape'
    },
    {
      title: '高效溝通與回饋',
      description: '掌握有效溝通技巧，建立正向回饋文化，提升團隊協作效率',
      duration: '3 小時工作坊',
      image: 'https://readdy.ai/api/search-image?query=business%20communication%20training%20workshop%20with%20professionals%20practicing%20feedback%20skills%2C%20modern%20conference%20room%20with%20interactive%20activities%2C%20people%20engaged%20in%20role%20play%20and%20communication%20exercises%2C%20professional%20photography%20showing%20effective%20communication%20techniques&width=600&height=400&seq=workshop003&orientation=landscape'
    }
  ];

  return (
    <section id="workshop" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-4">
          我們的工作坊，讓人流汗、卡關、對話 💪
        </h2>
        <p className="text-xl text-gray-600 text-center mb-16">
          不講漂亮理論，我們練會真實行為
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {workshops.map((workshop, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="h-64 w-full overflow-hidden">
                <img
                  src={workshop.image}
                  alt={workshop.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Noto Serif TC, serif' }}>
                  {workshop.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{workshop.description}</p>
                <div className="inline-block bg-orange-500 text-white px-4 py-1.5 rounded-full text-sm font-medium">
                  {workshop.duration}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gray-50 rounded-3xl p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">其他主題工作坊</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">主題式沉浸團建（1–3天）</h4>
                <p className="text-gray-600">信任突破營、協作破牆營、韌性與壓力管理營、高績效團隊營</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-heart-line text-2xl text-white"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">企業文化體驗共創團建</h4>
                <p className="text-gray-600">把文化從「牆上標語」變成「現場行為」，讓文化在團建中被體驗</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
